'use strict';

import Config           from '../config';
import HestiaSDK        from '@pixul/hestia-js-sdk';
import { useUserStore } from '@/store/user';
import Router           from '@/router';

export default new HestiaSDK({
  prefixUrl : Config.baseURL,
  timeout   : 1000000,
  headers   : {
    'content-type' : 'application/json'
  },
  hooks     : {
    beforeRequest : [
      request => {

        const store = useUserStore();

        if (store.token) {

          request.headers.set('Authorization', `Bearer ${ store.token }`);
        }

        if (request.url.match(/file\/\d+\/(download|preview)/gm) === null && Config.useLocalBackend === false) {
          request.headers.set('x-comms-frontend-path', Router.currentRoute.value.path);
          request.headers.set('x-comms-frontend-version', Config.version);
        }
      }
    ],
    afterResponse : [
      (request, options, response) => {

        if (response && response.status && response.status === 401) {
          const store = useUserStore();
          store.logout();
        }
      }
    ]
  }
});
